/**
 * This file was autogenerated by packages/aem-types-generator.
 * Do not edit manually.
 */

import type {BadgesInProgressCollectionSectionContentModel} from '../badgesIn/badgesInProgressCollectionSectionContent';
import type {BadgesInProgressSectionContentModel} from '../badgesIn/badgesInProgressSectionContent';
import type {HeaderSectionContentModel} from '../headerSectionContent';
import type {TabbedRewardsSectionContentModel} from '../tabbedRewardsSectionContent';

export const DynamicPageSectionItems = {
    HeaderSection: 'HEADER_SECTION',
    BadgesInProgressSection: 'BADGES_IN_PROGRESS_SECTION',
    BadgesCollectionSection: 'BADGES_COLLECTION_SECTION',
    BadgesInProgressCollectionSection: 'BADGES_IN_PROGRESS_COLLECTION_SECTION',
    TabbedRewardsSection: 'TABBED_REWARDS_SECTION',
} as const;

export type DynamicPageSectionType = (typeof DynamicPageSectionItems)[keyof typeof DynamicPageSectionItems];

export type DynamicPageSectionContent =
    | BadgesInProgressCollectionSectionContentModel
    | BadgesInProgressSectionContentModel
    | HeaderSectionContentModel
    | TabbedRewardsSectionContentModel;

export interface DynamicPageSectionModel {
    order?: number;
    id?: string;
    type: DynamicPageSectionType;
    content?: DynamicPageSectionContent;
}
